const defaultState = {};

export const systemReducer = (state = defaultState, action) => {
  let system = {};

  switch (action.type) {
    case "SAVE_SYSTEM":
      system = action.payload;

      localStorage.setItem("system", JSON.stringify(system));

      return system;

    case "REMOVE_SYSTEM":
      return defaultState;

    default:
      return state;
  }
};
